import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: format in this file is for backwards compatibility, however, it should likely be updated to more closely match the way the other track* files are written
// note the keys in defaultData below are all passed in through drupal JS currently, for an example, see:
// sites/bobbibrown/themes/bb_base/template_api/loyalty/loyalty_popup_offer_v1/src/loyalty_popup_offer_v1.js

const baseData: IDataLayer = {
  event_name: 'loyalty',
  event_category: 'loyalty',
  event_action: null, // depends on source of tag
  event_label: null, // depends on source of tag
  event_noninteraction: null
};

const defaultData: IDataLayer = {
  'account | signin': {
    event_action: 'sign up',
    event_label: 'click'
  },
  account: {
    event_action: 'account',
    event_label: 'join now'
  },
  'checkout | confirm': {
    event_action: 'checkout',
    event_label: 'join now'
  },
  'signup overlay': {
    event_action: 'enrolment overlay',
    event_label: 'displayed',
    event_noninteraction: true
  },
  'marketing enrollment': {
    event_action: 'cms',
    event_label: 'join now'
  },
  'enrollment overlay': {
    event_action: 'enrolment overlay',
    event_label: 'join now cta'
  },
  'marketing overlay': {
    event_action: 'cms',
    event_label: 'join now'
  },
  'apply offers': {
    event_action: 'account',
    event_label: 'apply offer'
  },
  'redeem rewards': {
    event_action: 'account',
    event_label: 'redeem'
  },
  'checkout redeem rewards': {
    event_action: 'checkout',
    event_label: 'redeem'
  },
  'checkout apply offers': {
    event_action: 'checkout',
    event_label: 'apply offer'
  },
  'checkout enrollment': {
    event_action: 'checkout',
    event_label: 'join now'
  },
  'checkout signup': {
    event_action: 'checkout',
    event_label: 'Sign up'
  },
  'marketing sign in': {
    event_action: 'cms',
    event_label: 'sign in now'
  },
  'cancel loyalty': {
    event_action: 'account',
    event_label: 'cancel'
  }
};

function trackLoyalty(eventName: string, eventData: IDataLayer = {}) {
  if (eventName && defaultData[eventName]) {
    tealium.evtLink({ ...baseData, ...defaultData[eventName], ...eventData });
  }
}

registerAnalyticsEventHandler('loyaltyTag', trackLoyalty);
